import { render, staticRenderFns } from "./EditPermission.vue?vue&type=template&id=6afed62c&"
import script from "./EditPermission.vue?vue&type=script&lang=js&"
export * from "./EditPermission.vue?vue&type=script&lang=js&"
import style0 from "./EditPermission.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../styles/table.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports